import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { rejectCartAPI } from 'src/api';
import { ToastStyled } from 'src/components';

export const useRejectCart = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      cartId,
      rejectNotes,
      layer,
    }: {
      cartId: string;
      rejectNotes: string;
      layer: number;
    }) => rejectCartAPI(cartId, rejectNotes, layer),
    onSuccess: (_, { cartId, rejectNotes }) => {
      queryClient.invalidateQueries({
        queryKey: ['cart', 'list'],
        exact: false,
        type: 'all',
        refetchType: 'active',
      });

      queryClient.invalidateQueries({
        queryKey: ['cart', 'get', cartId],
        exact: false,
        type: 'all',
        refetchType: 'active',
      });
    },
    onError: (error) => {
      toast.custom((toastBlock) => (
        <ToastStyled
          variant='error'
          handleClose={() => toast.dismiss(toastBlock)}
        >
          Failed to reject cart. Please try again.
        </ToastStyled>
      ));
    },
  });
};
